import {
  LOAD_AUDIENCE_ARTIST_OVERVIEW,
  UNLOAD_CURRENT_ARTIST,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const artistOverview = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
      return null;
    case LOAD_AUDIENCE_ARTIST_OVERVIEW:
      return loadReducer(state, action);
    default:
      return state;
  }
};
